var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f2e49f3310c316018848facfd7f1ad2d2ee124b9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nikolovlazardotcom@lazars-experiments"]={id:"f2e49f3310c316018848facfd7f1ad2d2ee124b9"};
      